import { NavBar, Collapse } from "bootstrap";
import 'swiper/swiper-bundle.min.css';
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/*
*
* JS Imports
*
* */
import Header from "./app/header";
import CollectionFilter from "./mx-collection-filter";
import Carousels from "./carousels";
import ProductRecommendations from "./product-recommendations";
import AboutHero from "./app/about-hero";
import Splitting from "splitting";
import StackingCards from "./app/stacking-cards";
import MediaGallery from "./app/sections/media-gallery";
import MiniNav from "./app/sections/mini-nav";
import MicroAnimation from "./app/micro-animation";
import FaqsFilter from "./app/faqs-filter";
import DestiniModal from "./app/destini-modal";
import MXShop from "./core/mx-shop";
import SingleRecipe from "./app/single-recipe";
import BlogGrid from "./app/blog";
import RelatedArticles from "./app/related-articles";
import InstagramSwiper from "./app/components/instagram-swiper";
import TwoColumnSwiper from "./app/sections/two-column-swiper";
import RelatedContentSwiper from "./app/components/related-content-swiper";
import RecipeCategories from "./app/sections/recipe-categories";
import TestimonialSwiper from "./app/sections/testimonial-swiper";
import ProductImagesSwiper from "./app/components/product-images-swiper";
import ProductCalloutSwiper from "./app/components/product-callout-swiper";
import FishCalculatorModal from "./app/fish-calculator-modal";
import Glossary from "./app/glossary";
import PasswordProtection from "./app/components/password-protection";
import CartAlert from "./app/components/cart-alert";
import StickyFilters from "./app/sections/product-filters";
import HeroCarouselSwiper from "./app/sections/hero-carousel-swiper"
import SearchBar from "./app/components/search-bar";

/** Core Cart Functions  */
MXShop( { cartAware : false, openOnAdd : false } )
/** // Core Cart Functions  */


Splitting();
Header();
AboutHero();
Carousels();
StackingCards(gsap, ScrollTrigger);
MediaGallery();
MiniNav();
MicroAnimation();
FaqsFilter();
DestiniModal();
SingleRecipe();
BlogGrid();
RelatedArticles();
InstagramSwiper();
TwoColumnSwiper();
RelatedContentSwiper();
RecipeCategories();
TestimonialSwiper();
ProductImagesSwiper();
ProductCalloutSwiper();
FishCalculatorModal();
Glossary();
PasswordProtection();
CartAlert();
HeroCarouselSwiper();

document.addEventListener('DOMContentLoaded', () => {
    SearchBar();
})

// Reload Swipers on shopify section changes
document.addEventListener( 'shopify:section:load', function( evt ){
    TwoColumnSwiper();
    RelatedContentSwiper();
    RecipeCategories();
    MediaGallery();
})

if (
    document.body.classList.contains('template-collection') ||
    document.body.classList.contains('template-blog')
) {
    StickyFilters();
}

const collectionFilter = new CollectionFilter({});
const productRecommendations = new ProductRecommendations(); 
// console.log( 'testing compiled' )